<template>
  <!-- TODO: alt 属性として nickname を当てられるようにする -->
  <img :src="iconUrl" class="iconImg" :style="style" alt="" />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class IconImage extends Vue {
  @Prop()
  iconUrl!: string

  @Prop({ default: 44 })
  size!: number

  @Prop({
    default() {
      return {}
    },
  })
  iconStyle!: { [k: string]: string }

  get style() {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
      border: '1px solid #e8e8e8',
      ...this.iconStyle,
    }
  }
}
</script>

<style scoped>
.iconImg {
  border-radius: 50%;
  object-fit: cover;
}
</style>
